const metricsEntityTypes = [
    {value: 0, text: 'Last 24 hours'},
    {value: 1, text: 'Last 7 days'},
    {value: 2, text: 'Last 30 days'},
    {value: 3, text: 'Yesterday'},
    {value: 4, text: 'All time'},
]

export { metricsEntityTypes as default }